import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import ExpandMore from '@mui/icons-material/ExpandMore';
import type { IconButtonProps } from '@mui/material/IconButton';

export interface ExpandCollapseButtonProps
  extends Omit<IconButtonProps, 'children'> {
  tooltipLabel?: string;
  expanded: boolean;
  disableTooltip?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default function ExpandCollapseButton({
  tooltipLabel,
  expanded = false,
  disableTooltip = false,
  onClick,
  ...rest
}: ExpandCollapseButtonProps) {
  const theme = useTheme();

  const buttonContent = (
    <span>
      <IconButton
        {...rest}
        size="small"
        onClick={onClick}
        aria-label={expanded ? 'Collapse' : 'Expand'}
      >
        <ExpandMore
          sx={{
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: theme.transitions.create('transform', {
              duration: theme.transitions.duration.shortest,
            }),
          }}
        />
      </IconButton>
    </span>
  );

  if (disableTooltip || !tooltipLabel) {
    return buttonContent;
  }

  return (
    <Tooltip arrow title={tooltipLabel || ''}>
      {buttonContent}
    </Tooltip>
  );
}
